import React from 'react';
import cx from 'classnames';

const DisplayMarkerSquare = (props) => {
    const {isSelected, handleUserMouseEnter, handleUserMouseLeave} = props;
    const {location, image, pos_y, pos_x, image_pos} = props.user;
    const positionClass = `user-square-picture-${image_pos}`;
    const classname = cx(positionClass, {
        "user-square-picture-selected": isSelected
    });

    return(
        <div
            className={cx("user-dot")}
            key={location}
            style={{top: pos_y, left: pos_x}}
            onMouseEnter={handleUserMouseEnter}
            onMouseLeave={handleUserMouseLeave}>
            <div className="user-dot-circle udc1"></div>
            <div className="user-dot-circle udc2"></div>
            <div className="user-dot-center"></div>
            <div
                className={classname}
                style={{backgroundImage: `url(${image})`}}></div>
        </div>
    );
};

export default DisplayMarkerSquare;



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/display_marker_square.js